





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { MenuItem } from '@/types/apiServerContract';
import Accordion from '@/core/ui-components/Accordion.vue';
import IAccordion from '@/core/ui-components/IAccordion';
import CategoryNameAndCount from '@/project/search/navigation/CategoryNameAndCount.vue';
import { NavigationItem } from '@/types/contentServerContract';

@Component({
    components: { CategoryNameAndCount, Accordion }
})
export default class NavigationTree extends Vue {
    @Prop({ required: true, type: Object })
    private menuItem!: MenuItem | NavigationItem;

    @Prop({ required: true })
    private selectedMenuItem!: MenuItem | NavigationItem | null;

    @Prop({ type: Boolean, default: false })
    private useRouteNavigation!: boolean;

    @Prop({ required: false, type: Number, default: 0 })
    private index!: number;

    @Prop({ type: Boolean, default: false })
    private last!: boolean;

    private selectMenuItem(menuItem: MenuItem | NavigationItem) {
        this.$emit('menuChanged', menuItem);
    }

    private get isActive() {
        return this.menuItem.id === this.selectedMenuItem?.id;
    }

    private isMenuActive(menuItem: MenuItem) {
        return menuItem.id === this.selectedMenuItem?.id || this.isMenuAChildOfMe(menuItem, this.selectedMenuItem?.url);
    }

    private startOpened: boolean = false;

    private shouldStartOpened() {
        return this.menuItem.children.length > 0 && (this.isActive || this.isMenuAChildOfMe(this.menuItem, this.selectedMenuItem?.url));
    }

    private validateReadyState() {
        this.startOpened = this.shouldStartOpened();
        if (this.startOpened) {
            this.$refs.accordion.open();
        } else {
            this.$refs.accordion.close();
        }
    }

    mounted() {
        this.validateReadyState();
    }

    @Watch('selectedMenuItem')
    onSelectedMenuChange(selectedMenu: MenuItem | NavigationItem) {
        this.validateReadyState();
    }

    private isMenuAChildOfMe(menuItem: MenuItem | NavigationItem, url?: string): boolean {
        if (!url || menuItem.children.length === 0) return false;

        for (const menu of menuItem.children) {
            if (menu.url === url) {
                return true;
            }

            if (menu.children.length > 0) {
                const found = this.isMenuAChildOfMe(menu, url);
                if (found) {
                    return found;
                }
            }
        }

        return false;
    }

    $refs!: Vue['$refs'] & {
        accordion: IAccordion
    }
}
